import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import { CssBaseline, CircularProgress, Container, Button, Grid } from "@mui/material"
import { withStyles } from "@mui/styles"
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import MyMaterialTable from '../../components/table'
import Api from "../../services/api"
import ApiReports from "../../services/apireport"; // Importante para chamar a API de relatórios
import ScheduleReportButton from "../../components/report-schedule";
import * as calledsActions from '../../redux/actions/calleds'
import { AbilityContext } from '../../config/ability-context'
import Footer from '../../components/footer'
import moment from "moment"
import { FormattedMessage, injectIntl } from 'react-intl'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import Divider from '@mui/material/Divider'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Pagination from '@mui/material/Pagination'

class FeedbackArticleReport extends Component {

  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false

    
    this.organizationId = null
    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item) => {
      if (item.role.roletype !== 3) this.isClient = false
      if (item.role.roletype === 0 || item.role.roletype === 1) this.isAdm = true
    });

    if (userSession.user.organization)
        this.organizationId = userSession.user.organization.id

    this.state = {
      
      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),

     
      hirerid: userSession.user.hirerid || null,

      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,
      
      
      feedbackList: [],
      columns: [],

      
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,
    }
  }


  changeValues = (stateName, value) => {
    this.setState({ [stateName]: value });
  };

  closeNotification = _ => {
    this.setState({ openNotification: false });
  }

  setPagination = (count, page) => {
    let totalPage = Math.ceil(count / 10) 
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        if (count < 10)
          this.setState({ pageStart: 1, pageEnd: count })
        else
          this.setState({ pageStart: 1, pageEnd: 10 })
      } else {
        let pageStart = ((page - 1) * 10) + 1
        if (count >= page * 10)
          this.setState({ pageStart: pageStart, pageEnd: page * 10 })
        else
          this.setState({ pageStart: pageStart, pageEnd: count })
      }
    } else
      this.setState({ totalPages: 0, page: 1, count: 0 })
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page })
    this.getFeedbackData(page)
  }

  getColumns() {
    const columns = [
      { title: "ID", field: 'id', width: 50 },
      { title: "Notícia", field: 'newstitle' },
      {
        title: "Data",
        field: 'feedbackdate', 
        render: rowData => rowData.feedbackdate ? moment(rowData.feedbackdate).format('DD/MM/YYYY HH:mm') : '-'
      },
      { title: "Opção", field: 'selectedoption' },
      { title: "Descrição", field: 'descriptiontext' },
      { title: "IP", field: 'ipaddress' },
    ];
    this.setState({ columns: columns })
  }


  getFeedbackData = async (page = 1) => {
    const intl = this.props.intl;
    this.setState({ loading: true });

    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');
    const hirerId = this.state.hirerid;

    if (moment(dateStart).isAfter(dateEnd)) {
        this.setState({
            openNotification: true,
            notificationVariant: "error",
            notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
            loading: false
        });
        return;
    }
     
    let url = `/report/feedback-article/paginate?page=${page}&startDate=${dateStart}&endDate=${dateEnd}`;

    // Agendamento de relatórios: captura o filtro exatamente como foi enviado.
    this.setState({ scheduleRequest: url })
    ApiReports.get(url)
      .then(result => {
        if (result.data.success) {
          
          let dataList = result.data.data || []; 
          let totalCount = result.data.count || dataList.length; 

          this.setState({ 
            count: totalCount, 
            feedbackList: dataList, 
            loading: false,
            showGrid: true
          });
          
          this.setPagination(totalCount, page);
          this.getColumns();

        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: result.data && result.data.errors && result.data.errors[0] ? result.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          });
        }
      })
      .catch(err => {
        this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        });
      })
  }

 
  exportRequest = () => {
    this.setState({ loading: true });
    
    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');
   
    let data = {
        StartDate: dateStart,
        EndDate: dateEnd
    };

    
    ApiReports.post(`/report/feedback-article/export`, data)
      .then((response) => {
        if (response.data.success) {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")",
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: response.data.errors && response.data.errors[0] ? response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: error.data && error.data.response && error.data.response.data && error.data.response.data.errors && error.data.response.data.errors[0] ? error.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        });
      });
  }

  handleSubmit = async e => {
    e.preventDefault();
    await this.getFeedbackData(1); 
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props
    const intl = this.props.intl

    if (!Api) return null;

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })} >
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />
            
            
            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card >
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      Relatório de Feedback de Notícias
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

           
            <form name='myForm' className={classes.form} onSubmit={this.handleSubmit}>
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3} >
                      <SimpleDatePicker
                        label={intl.formatMessage({ id: "start.date" })} 
                        name='dateStart' stateName='dateStart'
                        changeDate={this.changeValues} currentDate={this.state.dateStart}
                        fullWidth={true} required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} >
                      <SimpleDatePicker
                        label={intl.formatMessage({ id: "end.date" })} 
                        name='dateEnd' stateName='dateEnd'
                        changeDate={this.changeValues} currentDate={this.state.dateEnd}
                        fullWidth={true} required
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              
              <Grid container style={{ marginBottom: 10, marginTop: 10 }}>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10 }}>
                  <Button type='submit' fullWidth variant='contained' color='secondary'>
                    {<FormattedMessage id="filter" />}
                  </Button>
                </Grid>

               
                {this.state.showGrid && (
                  <Grid item xs={12} sm={5} md={2}>
                    <Button 
                        fullWidth 
                        variant='contained' 
                        color='secondary' 
                        onClick={this.exportRequest} 
                    >
                      {<FormattedMessage id="export.plan" />}
                    </Button>
                  </Grid>
                )}
{this.state.showGrid && this.state.scheduleRequest && <Grid item xs={12} sm={5} md={2}>
  <ScheduleReportButton reportKey="feedback-article" request={this.state.scheduleRequest} color="secondary" />
</Grid>}
              </Grid>
            </form>

           
            {this.state.showGrid && (
              <>
                <MyMaterialTable
                  title=""
                  columns={this.state.columns}
                  data={this.state.feedbackList}
                  options={{ paging: false, search: false }} 
                />
                
                <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                  <Grid item xs={12} md={3}>
                    <Pagination 
                        count={this.state.totalPages} 
                        page={this.state.page} 
                        onChange={this.onChangePaginate} 
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                    {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                  </Grid>
                </Grid>
              </>
            )}

            {this.state.loading && (
              <Overlay><CircularProgress color="secondary" /></Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

FeedbackArticleReport.propTypes = { classes: PropTypes.object.isRequired }

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch => bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(FeedbackArticleReport)))
FeedbackArticleReport.contextType = AbilityContext